import axios from 'axios';
import { IRecipe } from './IRecipe';

export interface AIRecipeRequest {
  action: 'generate' | 'generate_from_url' | 'refine';
  text?: string;
  url?: string;
  current_recipe?: Partial<IRecipe>;
  refinement_instructions?: string;
  conversation_history?: Array<{ role: 'user' | 'assistant'; content: string }>;
}

export interface AIRecipeResponse {
  proposal: Partial<IRecipe> | null;
  message: string;
  clarification_needed: boolean;
  error: { code: string; detail: string } | null;
}

export const generateAIRecipe = async (req: AIRecipeRequest): Promise<AIRecipeResponse> => {
  const response = await axios.post('/v1/ai/recipe', req);
  return response.data;
};
